import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import LiveStreamBoothExhibitorPanelContent
  from 'components/pictureInPicture/LiveStreamBoothExhibitorPanel/LiveStreamBoothExhibitorPanelContent';
import { CircularProgress } from '@material-ui/core';
import { useObservable } from 'react-use';
import createLiveStreamTokenObservable from 'network/createLiveStreamTokenObservable';

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const StyledSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  width: 100%;
  height: 100%;
`;

const LiveStreamBoothExhibitorPanel = ({ boothId }) => {
  const randomKey = useMemo(() => `${Math.random()}`, []);

  const agoraAccount = useMemo(() => `Exhibitor:${boothId}:${randomKey}`, [boothId, randomKey]);

  const liveStreamToken$ = useMemo(() => createLiveStreamTokenObservable(boothId, agoraAccount, 'host'), [agoraAccount, boothId]);

  const { agoraToken, realtimeDBToken } = useObservable(liveStreamToken$) ?? {};

  return (
    <MainContainer>
      {
        agoraToken == null ? (
          <StyledSpinnerContainer>
            <CircularProgress />
          </StyledSpinnerContainer>
        ) : (
          <LiveStreamBoothExhibitorPanelContent boothId={boothId} agoraToken={agoraToken} realtimeDBToken={realtimeDBToken} agoraAccount={agoraAccount} />
        )
      }
    </MainContainer>
  );
};

export default React.memo(LiveStreamBoothExhibitorPanel);
